var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelinux(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 311.783,
    height: 282.011,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "n",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.91531 0 0 .91531 2239.551 1022.706)",
    x1: 1194.631,
    y1: 412.295,
    x2: 1171.375,
    y2: 413.344
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9cd9f",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f9cd9f",
      stopOpacity: 0
    },
    offset: 1
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "m",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.87592 0 0 .84508 2877.878 1271.83)",
    x1: 3350.254,
    y1: 464.751,
    x2: 3359.737,
    y2: 461.956
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "l",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-1.05496 .06474 .05778 1.18208 4480.016 1225.353)",
    x1: 3368.67,
    y1: 504.722,
    x2: 3372.154,
    y2: 499.902
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6bb7c",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f6bb7c",
      stopOpacity: 0
    },
    offset: 1
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#c",
    id: "k",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.0553 .05732 -.05116 1.18247 2251.536 1235.549)",
    x1: 3343.341,
    y1: 502.409,
    x2: 3359.935,
    y2: 501.925
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#171815",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#171815",
      stopOpacity: 0
    },
    offset: 1
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "j",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.91531 0 0 .91531 2239.551 1022.706)",
    x1: 1271.343,
    y1: 427.079,
    x2: 1285.949,
    y2: 440.096
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#5d6b4c",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#daeac6",
      stopOpacity: 1
    },
    offset: 1
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#d",
    id: "i",
    x1: 3288.43,
    y1: 650.532,
    x2: 3315.624,
    y2: 598.501,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 -14.37)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#373737",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#171717",
      stopOpacity: 1
    },
    offset: 1
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#e",
    id: "h",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.91531 0 0 .91531 4402.845 2122.899)",
    x1: 3273.064,
    y1: 619.613,
    x2: 3358.183,
    y2: 619.613
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9fae8d",
      stopOpacity: 1
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    },
    offset: 1
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#f",
    id: "g",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.7061 0 0 .7061 1538.025 2255.665)",
    x1: -2564.118,
    y1: -2276.981,
    x2: -2479.45,
    y2: -2369.346
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a44",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#21211e",
      strokeWidth: 1.875,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M3357.781 439.25c-11.909.454-14.972 11.13-12.781 20.438-.199.064-.954.323-2.219.75-.056.019-.1.043-.156.062-7.156 2.417-26.965 9.4-23.719 11.719 1.975 1.41 8.064 2.581 14.094 3.125 1.09.098 2.19.196 3.25.25.005.748-.063 1.533-.188 2.375-1.464 9.865 3.916 23.718 20.876 25.219 12.991 1.149 22.909-9.338 24-19.094 5.045 2.1 10.1 3.66 12.28 3.406 4.238-.493-12.896-23.94-20.53-28.906 1.647-8.621-2.114-19.47-14.313-19.344-.194.002-.404-.007-.594 0z",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#f09c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#21211e",
      strokeWidth: 1.4254936,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3370.036 505.275c-6.563 1.869-10.646 3.395-10.208.7.429-2.633 4.981-5.293 9.357-6.545 4.685-1.341 12.474 4.312 12.567 6.682.076 1.945-6.465-1.861-11.716-.837z",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3351.104 505.275c6.677 1.869 10.832 3.395 10.386.7-.435-2.633-5.068-5.293-9.52-6.545-4.768-1.341-12.693 4.312-12.788 6.682-.077 1.945 6.579-1.861 11.922-.837z",
    style: {
      color: "#000",
      fill: "#f09c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#464640",
      strokeWidth: 1.00000036,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-1.76008 0 0 1.76008 5999.889 -918.774)",
    d: "M3302.504 581.503a40.305 40.305 0 1 1-.066.022",
    style: {
      color: "#000",
      fill: "url(#g)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.70055676,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "url(#h)",
      strokeWidth: 4.49084759,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3302.504 581.503a40.305 40.305 0 1 1-.066.022",
    transform: "matrix(1.76008 0 0 1.76008 -5671.631 -918.774)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#171815",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 3.70055676,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3358.394 466.871c-9.642-.236-16.962 11.88-12.003 20.258 3.814 7.669 15.482 10.288 21.74 3.993 5.816-5.273 6.29-15.762-.122-20.737-2.626-2.314-6.11-3.684-9.615-3.514z",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "url(#i)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "url(#linearGradient16015)",
      strokeWidth: 6.28939438,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3302.504 581.503a40.305 40.305 0 1 1-.066.022",
    transform: "matrix(.47276 0 0 .47276 -1403.347 -120.17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3358.394 466.871c-9.642-.236-16.962 11.88-12.003 20.258 3.814 7.669 15.482 10.288 21.74 3.993 5.816-5.273 6.29-15.762-.122-20.737-2.626-2.314-6.11-3.684-9.615-3.514z",
    style: {
      color: "#000",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 10,
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 0,
      strokeDasharray: "5,5",
      strokeDashoffset: 100,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 0.75,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.27666879,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m3359.274 494.806-.09-5.087M3358.795 472.188v-5.265M3367.448 480.757l5.266-.037M3344.781 481.146l5.266-.126M3351.45 468.782l1.507 2.9M3365.957 468.652l-1.506 2.901M3352.23 492.96l1.505-2.902M3365.93 492.96l-1.506-2.902M3371.232 474.157l-3.028 1.232",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3371.115 487.34-3.418-1.392",
    style: {
      fill: "none",
      fillOpacity: 0.75,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.27666831,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 0.75,
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.27666879,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m3349.307 476.038-3.028-1.233M3349.566 486.222l-3.027 1.232",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#f09c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#21211e",
      strokeWidth: 0.99999988,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3357.975 455.646c-4.837-.31-8.047.385-7.469 3.653.565 3.194 4.153 6.364 7.379 6.578 3.454.23 8.283-4.192 8.114-7.217-.14-2.481-4.2-3.363-8.024-3.014z",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3380.214 482.675c1.633-3.362-1.228-10.515-.783-10.996 1.437-1.553 9.395 14.266 9.395 14.266s-7.058-2.03-8.612-3.27z",
    style: {
      fill: "url(#j)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#f09c42",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#21211e",
      strokeWidth: 1.4254936,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3351.104 505.275c6.677 1.869 10.832 3.395 10.386.7-.435-2.633-5.068-5.293-9.52-6.545-4.768-1.341-12.693 4.312-12.788 6.682-.077 1.945 6.579-1.861 11.922-.837z",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "url(#k)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.09509909,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3351.594 498.531c-4.16-1.17-11.074 3.744-11.157 5.813-.067 1.697 5.743-1.613 10.407-.719 5.827 1.631 9.452 2.945 9.062.594-.38-2.299-4.427-4.595-8.312-5.688z",
    transform: "matrix(2.93225 -.14214 .12685 2.61692 -9759.901 -582.297)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-2.9313 .16054 .14327 2.61607 9955.52 -1593.822)",
    d: "M3351.594 498.531c-4.16-1.17-11.074 3.744-11.157 5.813-.067 1.697 5.743-1.613 10.407-.719 5.827 1.631 9.452 2.945 9.062.594-.38-2.299-4.427-4.595-8.312-5.688z",
    style: {
      color: "#000",
      fill: "url(#l)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.09509909,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "url(#m)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.31550419,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      marker: "none",
      markerStart: "none",
      markerMid: "none",
      markerEnd: "none",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      visibility: "visible",
      display: "inline",
      overflow: "visible"
    },
    d: "M3353.969 460.281c-2.545.19-4.035 1.08-3.657 3.219.493 2.788 3.623 5.563 6.438 5.75 3.015.2 7.241-3.673 7.094-6.313-.122-2.165-3.663-2.928-7-2.625-1.056-.067-2.027-.094-2.875-.03z",
    transform: "matrix(2.94778 0 0 3.05535 -9737.908 -1324.33)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#n)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M3336.755 475.518c.287-2.76 4.81-6.691 4.648-7.327-.52-2.05-13.496 6.285-13.496 6.285s6.891 1.39 8.848 1.042z",
    transform: "matrix(3.71092 0 0 3.71092 -12300.11 -1612.245)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c0c0c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.18040431,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M1199.95 373.875c-.21.771-.856 2.81-1.032 4 1.27 1.564 4.522 2.194 6 3.625.008.006.023.025.031.031.054.044.117.104.156.156.644.9-.321 2.972 6.282 4.97 7.056 2.133 8.32 1.918 9.937 1.437 1.618-.482 2.438-2.875 2.438-2.875s.548-2.892 2.593-3.125h.094c.043.002.084-.004.125 0h.031c2.046.233 2.594 3.125 2.594 3.125s.82 2.393 2.438 2.875c1.617.481 2.881.696 9.937-1.438 7.163-2.166 5.4-4.404 6.469-5.156 1.478-1.43 4.73-2.06 6-3.625-.176-1.19-.823-3.229-1.031-4a3.826 3.826 0 0 1-.032.031c-.414.217-4.704 2.79-5.125 2.969-1.14-2.38-2.803-2.47-10.312-.906-7.275 1.515-9.053 3.796-9.156 3.937h-3.813c-.103-.141-1.882-2.422-9.156-3.937-7.51-1.565-9.173-1.473-10.313.906-.42-.18-4.71-2.752-5.125-2.969a3.826 3.826 0 0 1-.03-.031z",
    transform: "translate(-2257.827 -685.192) scale(1.9731)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelinux);
export default __webpack_public_path__ + "static/media/selinux.43aaeb8d943ab66bb9d14b5984dc1fc0.svg";
export { ForwardRef as ReactComponent };